module.exports = __webpack_public_path__ + "img/gaoya-1.dde7c00d.svg";